import React from 'react';
import { Button, Grid, Header, Loader, Segment } from 'semantic-ui-react';
import { getCategories } from '../../api/egm';
import revenue from '../../api/revenue';
import { defaultGrid } from '../../helpers/datagrid';
import DataGrid from '../shared/DataGrid';
import ExpandButton from '../shared/ExpandButton';
import RevenueFilters from './RevenueFilters';
import RevenueGraph from './RevenueGraph';
import DetailsButton from '../shared/DetailsButton';

class BaseRevenueView extends React.Component {

  state = {
    expanded: false,
    selectedWeek: 8,
    selectedOperator: null,
    selectedViewType: null,
    selectedVarianceType: -1,
    selectedCategory: -1,
    selectedGroupBy: 0,
    selectedRegion: -1,
    selectedPromoType: -1,
    summary: defaultGrid,
    activeRow: {
      optionShowDetails: false,
    },
    graph: {
      lines: [],
      data: []
    },
    categories: [],
    loading: false,
    chartLoading: false,
    operators: this.props.operators,
    regions: []
  }

  componentDidMount() {
    this.setState({ selectedViewType: this.viewTypes[0].value, selectedVarianceType: this.viewTypes[0].graphOptions[0].value })
    this.handleOperatorChange(this.props.operators[0].value)
  }

  onRowClick = (activeRow) => {
    this.setState({ activeRow, chartLoading: true }, () => this.refreshGraph());
  }

  onGraphTypeChange = (selectedVarianceType) => {
    this.setState({ selectedVarianceType }, () => this.refreshGraph());
  }

  handleOperatorChange = selectedOperator => {
    this.setState({ selectedOperator, selectedCategory: -1 }, () => {
      revenue.getRegions(selectedOperator).then(regions => this.setState({ regions }))
      getCategories(selectedOperator).then(categories => this.setState({ categories }))
    });
  }

  onViewTypeChange = (value) => {
    const selectedViewType = this.viewTypes.find(x => x.value === value)
    const selectedVarianceType = selectedViewType.graphOptions.length > 0 ? selectedViewType.graphOptions[0].value : -1;
    this.setState({ activeRow: { optionShowDetails: false }, selectedVarianceType, graph: { lines: [], data: [] }, selectedViewType: value })
  }

  onFilterChange = (key, value) => this.setState({ [key]: value })

  render() {
    const { selectedViewType, summary, graph, selectedVarianceType, activeRow, loading, chartLoading, expanded, detailsLoading } = this.state;
    const dataTypes = selectedViewType !== null ? this.viewTypes.find(x => x.value === selectedViewType).graphOptions : [];

    return (
      <div className="height-100 gs-flex-container-vertical">
        <Header size="small" className="my-0">Summary Dashboard
          <Button floated="right" compact icon="refresh" positive onClick={this.handleRefresh} content="Refresh" loading={loading} disabled={loading} />
          <DetailsButton floated="right" compact loading={detailsLoading} disabled={!activeRow.optionShowDetails} onClick={this.onDetailsClick} />
          <ExpandButton size="medium" active={expanded} content={ expanded ? "Display Graph" : "Hide Graph"} onClick={() => this.setState({ expanded: !expanded })} />
        </Header>
        <Segment className="flex-stretch my-0_5">
          <Grid className="gs-flex-container-vertical height-100">
            <Grid.Row className="flex-shrink">
              <Grid.Column width="16" verticalAlign="middle">
                <RevenueFilters 
                  {...this.state}
                  useGroupBy={this.useGroupBy}
                  viewTypes={this.viewTypes}
                  onViewTypeChange={this.onViewTypeChange}
                  isVariance={this.isVariance}
                  varianceTypes={dataTypes}
                  onOperatorChange={this.handleOperatorChange}
                  onChange={this.onFilterChange}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row className="flex-stretch">
              <Grid.Column className="gs-flex-container-vertical">
                <DataGrid
                  groupHeadings={summary.span}
                  headings={summary.headerDef}
                  activeRow={activeRow}
                  data={summary.data}
                  loading={loading}
                  rowDef={summary.rowDef}
                  hideOverflow
                  onRowClick={this.onRowClick}
                  fullHeight
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>

        {!expanded &&
          <Segment className="flex-shrink">
            <Loader active={chartLoading} />
              <div className="flex-vertical h-100">
                { dataTypes.length > 0 &&
                <div className="flex-shrink mr-1" style={{ textAlign: "center" }}>
                  <div className="mb-0_5" style={{ fontWeight: "bold" }}>Data Type:</div>
                  <Button.Group basic vertical>
                    {dataTypes.map(option => {
                      return <Button disabled={!activeRow.siteId} active={selectedVarianceType === option.value} onClick={() => this.onGraphTypeChange(option.value)}>{option.text}</Button>
                    })}
                  </Button.Group>
                </div>
                }
                <div className='flex-stretch flex-container'>
                  <div style={{ border: "1px solid #ddd", padding: "1em 1em 0em 2em" }}>
                    <Loader active={chartLoading} />
                    <RevenueGraph data={graph.data} lines={graph.lines} symbol={graph.symbol} />
                  </div>
                </div>
              </div>
          </Segment>
        }
      </div>
    );
  }
}

export default BaseRevenueView;